module.exports = __webpack_public_path__ + "img/Comic03-4.d2580093.png";